export default function disabledTime(current, rangeDate) {
  console.log(
    'current ',
    current,
    'range ',
    rangeDate[0],
    current === rangeDate[0]
  );
  return {
    disabledHours: () =>
      Array.from({ length: 24 }, (_, i) => i).filter(
        (hour) =>
          (current <= rangeDate[0] && hour < rangeDate[0]?.hour()) ||
          (current >= rangeDate[1] && hour > rangeDate[1]?.hour())
      ),
    disabledMinutes: () =>
      Array.from({ length: 60 }, (_, i) => i).filter(
        (min) =>
          (current <= rangeDate[0] && min < rangeDate[0]?.minute()) ||
          (current >= rangeDate[1] && min > rangeDate[1]?.minute())
      ),
    disabledSeconds: () =>
      Array.from({ length: 60 }, (_, i) => i).filter(
        (second) =>
          (current <= rangeDate[0] && second < rangeDate[0]?.second()) ||
          (current >= rangeDate[1] && second > rangeDate[1]?.second())
      ),
  };
}
